import React, { useMemo } from "react";
import { Link } from "react-router-dom";
import "./digitalTransformationDay.css";

const TIMELINE = [
  {
    time: "22/4/2022",
    title: "Ban hành Quyết định 505/QĐ-TTg",
    desc: "Thủ tướng Chính phủ quyết định lấy ngày 10/10 hằng năm là Ngày Chuyển đổi số quốc gia, nhằm thúc đẩy triển khai Chương trình Chuyển đổi số quốc gia đến năm 2025, định hướng đến năm 2030.",
    icon: "📜",
  },
  {
    time: "Ý nghĩa con số 10/10",
    title: "Hai ký tự của hệ nhị phân",
    desc: "“1” và “0” là hai ký tự cơ bản trong hệ nhị phân — nền tảng của công nghệ thông tin và chuyển đổi số.",
    icon: "💻",
  },
  {
    time: "10/10 hằng năm",
    title: "Lan tỏa nhận thức về chuyển đổi số",
    desc: "Nâng cao nhận thức của toàn dân về vai trò, ý nghĩa và lợi ích của chuyển đổi số; thúc đẩy sự tham gia của cả hệ thống chính trị, doanh nghiệp và người dân.",
    icon: "🌐",
  },
  {
    time: "1/10 – 10/10/2026",
    title: "Chủ đề năm 2026",
    desc: "“Chuyển đổi số quốc gia: Từ kiến trúc, nền tảng, dữ liệu đến kết quả thực chất, nâng cao hiệu quả quản trị quốc gia” — chiến dịch truyền thông do Bộ Khoa học và Công nghệ phát động.",
    icon: "🎯",
  },
];

const FACTS = [
  { num: "10/10", unit: "Hằng năm", label: "Ngày Chuyển đổi số quốc gia" },
  { num: "2022", unit: "Quyết định", label: "Số 505/QĐ-TTg của Thủ tướng Chính phủ" },
  { num: "3", unit: "Trụ cột", label: "Chính phủ số – Kinh tế số – Xã hội số" },
  { num: "2030", unit: "Định hướng", label: "Chương trình Chuyển đổi số quốc gia" },
];

export default function DigitalTransformationDay() {
  // Các chữ số nhị phân "1" / "0" bay lên — ý nghĩa của con số 10/10
  const digits = useMemo(
    () =>
      Array.from({ length: 28 }, (_, i) => ({
        id: i,
        char: Math.random() < 0.5 ? "1" : "0",
        left: Math.random() * 100,
        delay: Math.random() * 14,
        duration: 10 + Math.random() * 12,
        size: 12 + Math.random() * 18,
        opacity: 0.25 + Math.random() * 0.45,
      })),
    []
  );

  return (
    <div className="dt-page">
      {/* ===== HERO ===== */}
      <section className="dt-hero">
        <div className="dt-hero__bg" />

        {digits.map((g) => (
          <span
            key={g.id}
            className="dt-binary"
            style={{
              left: `${g.left}%`,
              animationDelay: `${g.delay}s`,
              animationDuration: `${g.duration}s`,
              fontSize: `${g.size}px`,
              opacity: g.opacity,
            }}
          >
            {g.char}
          </span>
        ))}

        <div className="dt-hero__content">
          <div className="dt-vn-star" />

          <div className="dt-date-badge">
            <span className="dt-date-num">10.10</span>
            <span className="dt-date-unit">2026</span>
          </div>

          <h1 className="dt-title">
            NGÀY CHUYỂN ĐỔI SỐ
            <br />
            QUỐC GIA
          </h1>

          <div className="dt-date-banner">Chuyển đổi số – Kiến tạo tương lai</div>

          <p className="dt-subtitle">
            Hưởng ứng Ngày Chuyển đổi số quốc gia 10/10/2026 với chủ đề
            “Chuyển đổi số quốc gia: Từ kiến trúc, nền tảng, dữ liệu đến kết
            quả thực chất, nâng cao hiệu quả quản trị quốc gia”.
          </p>

          <div className="dt-ribbon">
            <div className="dt-ribbon__bar" />
            <span className="dt-ribbon__star">★</span>
            <div className="dt-ribbon__bar" />
          </div>

          <Link to="/" className="dt-back-btn">
            ← Về trang chủ
          </Link>
        </div>
      </section>

      {/* ===== TIMELINE ===== */}
      <section className="dt-section dt-tl-section">
        <div className="dt-container">
          <h2 className="dt-section-title">
            <span className="dt-title-line" />
            Hành trình Chuyển đổi số
            <span className="dt-title-line" />
          </h2>

          <div className="dt-timeline">
            <div className="dt-tl-axis" />
            {TIMELINE.map((ev, i) => {
              const isLeft = i % 2 === 0;
              return (
                <div key={i} className="dt-tl-row">
                  {isLeft ? (
                    <>
                      <div className="dt-tl-card dt-tl-card--right">
                        <div className="dt-tl-time">{ev.time}</div>
                        <div className="dt-tl-heading">{ev.title}</div>
                        <div className="dt-tl-desc">{ev.desc}</div>
                      </div>
                      <div className="dt-tl-dot">{ev.icon}</div>
                      <div className="dt-tl-spacer" />
                    </>
                  ) : (
                    <>
                      <div className="dt-tl-spacer" />
                      <div className="dt-tl-dot">{ev.icon}</div>
                      <div className="dt-tl-card dt-tl-card--left">
                        <div className="dt-tl-time">{ev.time}</div>
                        <div className="dt-tl-heading">{ev.title}</div>
                        <div className="dt-tl-desc">{ev.desc}</div>
                      </div>
                    </>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* ===== FACTS ===== */}
      <section className="dt-section dt-facts-section">
        <div className="dt-container">
          <h2 className="dt-section-title">
            <span className="dt-title-line" />
            Chuyển đổi số qua những con số
            <span className="dt-title-line" />
          </h2>

          <div className="dt-facts-grid">
            {FACTS.map((a, i) => (
              <div key={i} className="dt-fact-card">
                <div className="dt-fact-num">{a.num}</div>
                <div className="dt-fact-unit">{a.unit}</div>
                <div className="dt-fact-label">{a.label}</div>
              </div>
            ))}
          </div>

          <p className="dt-facts-source">
            Nguồn: Quyết định 505/QĐ-TTg ngày 22/4/2022; Chương trình Chuyển
            đổi số quốc gia (Quyết định 749/QĐ-TTg)
          </p>
        </div>
      </section>

      {/* ===== QUOTE ===== */}
      <section className="dt-section dt-quote-section">
        <div className="dt-container">
          <blockquote className="dt-quote">
            <div className="dt-quote__mark">"</div>
            <p className="dt-quote__text">Chuyển đổi số – Kiến tạo tương lai</p>
            <footer className="dt-quote__author">
              — Thông điệp hưởng ứng Ngày Chuyển đổi số quốc gia 10/10,
              Bệnh viện Hùng Vương Gia Lai
            </footer>
          </blockquote>
        </div>
      </section>

      {/* ===== FOOTER ===== */}
      <footer className="dt-footer">
        <div className="dt-vn-star dt-vn-star--sm" />
        <div className="dt-footer-text">
          Hệ thống Y tế Hùng Vương Gia Lai hưởng ứng{" "}
          <strong>Ngày Chuyển đổi số quốc gia 10/10</strong> — đẩy mạnh ứng
          dụng công nghệ số trong khám, chữa bệnh và chăm sóc người bệnh.
        </div>
        <div className="dt-vn-star dt-vn-star--sm" />
      </footer>
    </div>
  );
}
